<img class="spinner" src="./assets/svgs/loading.svg">
